import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { UserCustom } from '../../types';
import { getErrorText } from '../helpers';

export type UpdateUserMetadata = { blocked?: string; alreadySpeakTotal?: string | number };

type Params = Pubnub.SetUUIDMetadataParameters<UserCustom>;
type Response = Pubnub.SetUUIDMetadataResponse<UserCustom>;

export const setUserMetadata = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/setUserMetadata',
  async (params, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;

      if (pubnubReducer.pubnub) {
        const result = await pubnubReducer.pubnub.objects.setUUIDMetadata({
          uuid: params.uuid,
          data: params.data,
          include: {
            customFields: true,
          },
        });

        return result;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
